import type { FeatureKey } from '@app/features/feature-keys.generated'
import featuresData from '@tenant-config/features/quebec_env.json'
import configData from '@tenant-config/tenants/quebec_env.json'

export const tenant: 'quebec_env' | 'canada_env' = 'quebec_env'
export const features = featuresData as Readonly<Record<FeatureKey, boolean>>
export const tenantConfig = configData
